import { PrismButton } from "@prism-ui/react";
import { useNavigate } from "react-router";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="not-found-page" style={{paddingTop: "2em"}}>
      <h2>404 This is an unknown page.</h2>
      <PrismButton tone="primary" onPrismClick={() => navigate("/")}>
        Return Home
      </PrismButton>
    </div>
  )
}

export default NotFound
